import { Enum, EnumType } from 'ts-jenum';

@Enum<LongRunningContextCategoryTyp>('value')
export class LongRunningContextCategoryTyp extends EnumType<LongRunningContextCategoryTyp>() {
   static readonly CALL_HISTORY = new LongRunningContextCategoryTyp('CALL_HISTORY');
   static readonly DIRECTORY_SEARCH = new LongRunningContextCategoryTyp('DIRECTORY_SEARCH');
   static readonly BRICK_WALL = new LongRunningContextCategoryTyp('BRICK_WALL');
   static readonly CALL_TAGS = new LongRunningContextCategoryTyp('CALL_TAGS');
   static readonly SKILLS = new LongRunningContextCategoryTyp('SKILLS');
   static readonly SETTINGS = new LongRunningContextCategoryTyp('SETTINGS');
   static readonly CONTACT_STATUS = new LongRunningContextCategoryTyp('CONTACT_STATUS');
   static readonly GLOBAL = new LongRunningContextCategoryTyp('GLOBAL');
   static readonly AUTHENTICATION = new LongRunningContextCategoryTyp('AUTHENTICATION');
   static readonly GRID_FILTERS = new LongRunningContextCategoryTyp('GRID_FILTERS');
   static readonly MAIL_WAITLIST = new LongRunningContextCategoryTyp('MAIL_WAITLIST');
   static readonly EMAIL_WINDOW = new LongRunningContextCategoryTyp('EMAIL_WINDOW');
   static readonly DIRECTORY_WINDOW = new LongRunningContextCategoryTyp('DIRECTORY_WINDOW');
   static readonly CHAT_WINDOW = new LongRunningContextCategoryTyp('CHAT_WINDOW');
   static readonly AGENT_DETAILS = new LongRunningContextCategoryTyp('AGENT_DETAILS');
   static readonly DIRECTORY_DETAILS = new LongRunningContextCategoryTyp('DIRECTORY_DETAILS');
   static readonly CHANGE_PASSWORD = new LongRunningContextCategoryTyp('CHANGE_PASSWORD');

   private constructor(public value: string) {
      super();
   }
}
